import { QueryKeys } from "@/constants";
import { useNotificationError } from "@/context/error-provider";
import { ErrorNotificationType } from "@/pages/components/error-notification";
import httpClient from "@/services";
import { useMutation } from "@tanstack/react-query";

type IFeedbackRequest = {
  groupId: string;
  loginGroupId: string;
  email: string;
  name: string;
  message: string;
};

const feedbackRequest = async (info: IFeedbackRequest) => {
  const payloadData = {
    groupId: info.groupId,
    loginGroupId: info.loginGroupId,
    email: info.email,
    name: info.name,
    message: info.message,
  };

  const config = {
    method: "POST",
    url: "application/feedback",
    headers: {
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => response.data);
};

export const useMFeedback = () => {
  const { addError } = useNotificationError();

  return useMutation({
    mutationKey: [QueryKeys.FEEDBACK],
    mutationFn: (info: IFeedbackRequest) => feedbackRequest(info),
    onSuccess: (response) => {
      if (!response.email_success) {
        addError({
          message: response.message,
          type: ErrorNotificationType.ERROR,
        });
      } else {
        addError({
          message: response.message,
          type: ErrorNotificationType.INFO,
        });
      }
    },
    onError: (error) => {
      addError({
        message: error.message,
        type: ErrorNotificationType.ERROR,
      });
    },
  });
};
